import {FC} from 'react'
import {Content} from '@prismicio/client'
import {PrismicRichText, SliceComponentProps} from '@prismicio/react'
import {Container} from 'src/common/Container'
import {ProductCard} from './components/ProductCard'

export type ProductDeepDiveV2Props = SliceComponentProps<Content.ProductDeepDiveV2Slice>

const ProductDeepDiveV2: FC<ProductDeepDiveV2Props> = ({slice}) => {
  return (
    <Container
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      backgroundColor="Dark Green"
      className="overflow-visible max-md:py-10 lg:py-20"
    >
      <div className="flex w-full max-w-[1200px] flex-col gap-12 px-5 md:gap-16 md:px-10 lg:px-5 xl:px-0">
        <div className="flex flex-col gap-3 md:gap-6">
          <PrismicRichText
            field={slice.primary.tag}
            components={{
              paragraph: ({children}) => (
                <p className="text-tg-body-s md:text-button-s font-semibold uppercase text-moss-white/[70%]">
                  {children}
                </p>
              ),
              strong: ({children}) => <strong className="pr-3 font-semibold text-[#CCFF3F]">{children}</strong>,
            }}
          />
          <div className="flex flex-col">
            <PrismicRichText
              field={slice.primary.heading}
              components={{
                heading1: ({children}) => (
                  <h1 className="md:text-tg-h1 text-[32px] font-normal leading-9 tracking-[-.32px] text-moss-white">
                    {children}
                  </h1>
                ),
                strong: ({children}) => (
                  <>
                    <br className="max-lg:hidden" />
                    <span className="md:text-tg-h1 font-normal text-moss-white/[70%]">{children}</span>
                  </>
                ),
              }}
            />
          </div>
        </div>
        <div className="grid-base grid-rows-2 max-lg:gap-5">
          {slice.primary.products.map((product, index) => (
            <ProductCard key={index} product={product} index={index} />
          ))}
        </div>
      </div>
    </Container>
  )
}

export default ProductDeepDiveV2
